import React from 'react';
import PropTypes from 'prop-types';
import { getClass, noop } from '../../helper';
import { SwitchProps } from './type';
import './style.scss';

const SwitchPropTypes = {
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  id: PropTypes.string,
  isOn: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

const SwitchDefaultProps = {
  onClick: noop,
  onChange: noop,
  isOn: false,
};

export function Switch({
  id,
  isOn,
  onClick,
  onChange,
  ariaLabel,
  ...props
}: SwitchProps) {
  return (
    <label
      data-testid={`elmo-toggle-btn-label-${id || 'default'}`}
      aria-label={ariaLabel || 'Toggle'}
    >
      <input
        className="elmo-toggle-btn__toggle-input"
        data-testid={`elmo-toggle-btn-input-${id || 'default'}`}
        type="checkbox"
        checked={isOn}
        onChange={onChange}
        onClick={onClick}
      />
      <span
        className={getClass('elmo-toggle-btn', '', { on: isOn })}
        {...props}
      />
    </label>
  );
}

Switch.propTypes = SwitchPropTypes;
Switch.defaultProps = SwitchDefaultProps;
